import { providerDropdown } from '@/fetchers/backend-fetchers';
import { ProviderQueryParams } from '@/state/state.types';
import { useQuery } from '@tanstack/react-query';

export const useProviderDropdown = (params: ProviderQueryParams) => {
  const { search, value } = params;

  // --- Base list (search or default)
  const { data: baseList = [], isLoading: baseLoading } = useQuery({
    queryKey: ['providers-dropdown', search ?? ''],
    queryFn: () => providerDropdown(search),
    select: (data) => data?.data ?? [],
    enabled: !!params,
  });

  const singleProviderFetchingCondn = !!value && !baseList.some((p) => p.value === value);

  // --- Fetch single provider by UUID if missing from baseList
  const { data: singleProvider, isLoading: singleLoading } = useQuery({
    queryKey: ['provider-by-value', value],
    queryFn: () => (value ? providerDropdown(null, value) : Promise.resolve(undefined)),
    enabled: singleProviderFetchingCondn,
    select: (data) => data?.data?.[0],
  });

  // --- Merge results
  const merged = singleProvider
    ? [...baseList.filter((opt) => opt.value !== singleProvider.value), singleProvider]
    : baseList;

  return {
    providerDropdown_: merged,
    isLoading: baseLoading || (singleLoading && singleProviderFetchingCondn),
  };
};
